<template>
  <v-row no-gutters>
    <v-col>
      <v-toolbar dense :elevation="0" class="rpd-toolbar-2layer">
        <div style="width:100%; display: flex; flex-wrap: nowrap; align-items: center;">
          <div class="text-primary-700 fit-content" style="font-weight: 700; display: grid;">
            <span style="font-size: large">My Properties</span>
            <!-- navigate to https://rp-database.com/docs/features/my-properties-page on click -->
            <!-- <a href="https://rp-database.com/docs/features/my-properties-page" target="_blank" rel="noopener noreferrer" class="pa-0 ml-1" dense small>
              <v-icon class="grey--text lighten-2" style="font-size:1.25rem">mdi-help-circle</v-icon>
            </a> -->   
            <span style="margin-top:-10px">
              <a href="https://rp-database.com/docs/features/my-properties-page" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
            </span>
          </div>
            
          <v-spacer></v-spacer>
          <v-btn-toggle class="ml-2"
                        v-model="tableType"
                        tile
                        group
                        mandatory
                        style="max-width:fit-content"

          >
            <v-btn value="all" class="group-tab-btn mt-0 mb-0" small>
              All properties
            </v-btn>

            <!-- tooltip -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-badge class="ml-2" overlap bordered :content="tabCount.upcoming_rent_reviews" :value="tabCount.upcoming_rent_reviews > 0" :style="`margin-right:${badgeMargin(tabCount.upcoming_rent_reviews)}px`">
                  <v-btn v-on="on" value="upcoming_rent_reviews" class="group-tab-btn" small :style="tabCount.upcoming_rent_reviews > 9 ? `margin-right:-${badgeMargin(tabCount.upcoming_rent_reviews) - 20}px; padding-right:${badgeMargin(tabCount.upcoming_rent_reviews)}px` : ''">
                    Upcoming rent reviews
                  </v-btn>
                </v-badge>
              </template>
              <span>Properties where the rent review date is less than 12 months from today</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-badge class="ml-2" overlap bordered :content="tabCount.upcoming_lease_renewals" :value="tabCount.upcoming_lease_renewals > 0" :style="`margin-right:${badgeMargin(tabCount.upcoming_lease_renewals)}px`">
                  <v-btn v-on="on" value="upcoming_lease_renewals" class="group-tab-btn" small :style="tabCount.upcoming_rent_reviews > 9 ? `margin-right:-${badgeMargin(tabCount.upcoming_lease_renewals) - 20}px; padding-right:${badgeMargin(tabCount.upcoming_lease_renewals)}px` : ''">
                    Upcoming lease renewals
                  </v-btn>
                </v-badge>
              </template>
              <span>Properties where the lease end date is less than 12 months from today</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-badge class="ml-2" overlap bordered :content="tabCount.vacant" :value="tabCount.vacant > 0" :style="`margin-right:${badgeMargin(tabCount.vacant)}px`">
                  <v-btn v-on="on" value="vacant" class="group-tab-btn" small :style="tabCount.vacant > 9 ? `margin-right:-${badgeMargin(tabCount.vacant) - 20}px; padding-right:${badgeMargin(tabCount.vacant)}px` : ''">
                    Vacant
                  </v-btn>
                </v-badge>
              </template>
              <span>Properties where the tenant is vacant</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-badge class="ml-2" overlap bordered :content="tabCount.without_lease" :value="tabCount.without_lease > 0" :style="`margin-right:${badgeMargin(tabCount.without_lease)}px`">
                  <v-btn v-on="on" value="without_lease" class="group-tab-btn" small :style="tabCount.without_lease > 9 ? `margin-right:-${badgeMargin(tabCount.without_lease) - 20}px; padding-right:${badgeMargin(tabCount.without_lease)}px` : ''">
                    Without lease data
                  </v-btn>
                </v-badge>
              </template>
              <span>Properties where the lease data is missing</span>
            </v-tooltip>

          </v-btn-toggle>
        </div>
        <!--</v-col>-->
        <!--<v-col lg="auto">-->

        <!--</v-col>-->
        <!--</v-row>-->
        <div class="mt-4 mb-2" style="width: 100%; display: -webkit-box; flex-wrap: nowrap; align-items: center;">
          <div style="display: -webkit-box; align-items: center;">
            <v-autocomplete
              
              v-model="schemeFilter"
              :loading="schemes.loading"
              :items="schemes.items"
              :search-input.sync="schemes.search"
              cache-items
              flat
              hide-no-data
              outlined
              dense
              clearable
              item-text="name"
              item-value="id"
              label="Scheme"
              @change="getData"
              class="pt-0 mr-2 fit-content"
              hide-details
            ></v-autocomplete>
            <v-checkbox v-model="showLeaseInfo" class="mx-2 align-center mt-0 pt-0" hide-details
                          label="Lease Info"></v-checkbox>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                  <v-checkbox v-model="propertyType" v-on="on" class="mx-2 align-center  mt-0 pt-0" hide-details label="Company Properties"></v-checkbox>
              </template>
              <span>Toggle between viewing all properties that you are personally set as a contact for,<br/> or all properties that your company is set as a contact for.</span>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>
          <div>
              <v-menu offset-y>
                <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn
                        color="primary"
                        dark
                        height="40"
                        v-on="{ ...onMenu, ...onTooltip }"
                        outlined
                        style="float:right"
                      >
                        <v-icon>mdi-plus</v-icon>
                        Add Properties
                      </v-btn>
                    </template>
                    <span>Add yourself as a contact to properties to show them on this page</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item @click="() => routeToAddMe('scheme')">
                    <v-list-item-content>
                      <v-list-item-title>Add me as Landlord/Landlords Agent</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="() => routeToAddMe('property')">
                    <v-list-item-content>
                      <v-list-item-title>Add me as Tenant/Tenants Agent</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu
                v-model="filtersMenu"
                :close-on-content-click="false"
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <!-- <v-badge class="mr-4 ml-2 mt-1" style="float:right" overlap bordered :value="filtersCount > 0"> -->
                  <v-badge class="mr-4 ml-2" color="red" style="float:right" overlap bordered :value="filtersCount > 0">
                    <v-btn height="40" outlined v-on="on" class="ml-1">
                      <v-icon>mdi-table-search</v-icon>
                      Filters
                    </v-btn>
                  </v-badge>
                </template>

                <v-card style="width: 500px;">
                <v-card-title>
                  <h4 class="text-primary-700">Filters</h4>
                  <v-spacer></v-spacer>
                  <v-btn class="ml-2" outlined @click="resetFilters">
                    Reset
                  </v-btn>
                </v-card-title>
                <v-divider class="mx-2"></v-divider>
                <v-card-text class="rpd-filter-card-text pb-8">
                  <h5 class="text-h7 mb-1 pa-0">Size</h5>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="sizeFrom"
                        type="number"
                        label="Size Min"
                        @change="getData"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                      outlined
                      dense
                      hide-details
                        v-model="sizeTo"
                        type="number"
                        label="Size Max"
                        @change="getData"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-divider class="my-8"></v-divider>

                  <h5 class="text-h7 mb-1 pa-0">Landlords</h5>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-autocomplete
                        outlined
                        
                        v-model="landlordFilter"
                        :loading="landlords.loading"
                        :items="landlords.items"
                        :search-input.sync="landlords.search"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        deletable-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlords"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        outlined      
                        deletable-chips
                        v-model="landlordContactFilter"
                        :loading="landlordContacts.loading"
                        :items="landlordContacts.items"
                        :search-input.sync="landlordContacts.search"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordAgentFilter"
                        :loading="landlordAgents.loading"
                        :items="landlordAgents.items"
                        :search-input.sync="landlordAgents.search"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        outlined      
                        deletable-chips
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Agents"
                        @change="getData"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="landlordAgentContactFilter"
                        :loading="landlordAgentContacts.loading"
                        :items="landlordAgentContacts.items"
                        :search-input.sync="landlordAgentContacts.search"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        small-chips
                        outlined      
                        deletable-chips
                        hide-details
                        multiple
                        item-text="name"
                        item-value="id"
                        label="Landlord Agent Contacts"
                        @change="() => {getData();}"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                <v-divider class="my-8"></v-divider>

                <h5 class="text-h7 mb-1 pa-0">Tenants</h5>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="tenantFilter"
                      :loading="tenants.loading"
                      :items="tenants.items"
                      :search-input.sync="tenants.search"
                      cache-items
                      flat
                      hide-no-data
                      clearable
                      small-chips
                      outlined
                      dense
                      multiple
                      item-text="name"
                      item-value="id"
                      label="Tenant"
                      @change="getData"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="tenantLegalFilter"
                      :loading="legalTenants.loading"
                      :items="legalTenants.items"
                      :search-input.sync="legalTenants.search"
                      cache-items
                      flat
                      hide-no-data
                      clearable
                      small-chips
                      outlined      
                      deletable-chips
                      multiple
                      item-text="name"
                      item-value="id"
                      label="Tenant (Legal)"
                      @change="getData"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="tenantContactFilter"
                      :loading="tenantContacts.loading"
                      :items="tenantContacts.items"
                      :search-input.sync="tenantContacts.search"
                      cache-items
                      flat
                      hide-no-data
                      clearable
                      small-chips
                      outlined      
                      deletable-chips
                      multiple
                      item-text="name"
                      item-value="id"
                      label="Tenant Contacts"
                      @change="() => {getData();}"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="tenantAgentFilter"
                      :loading="tenantAgent.loading"
                      :items="tenantAgent.items"
                      :search-input.sync="tenantAgent.search"
                      cache-items
                      flat
                      hide-no-data
                      clearable
                      small-chips
                      outlined      
                      deletable-chips
                      multiple
                      item-text="name"
                      item-value="id"
                      label="Tenant Agent"
                      @change="() => {getData();}"
                    ></v-autocomplete>      
                  </v-col>
                  <v-col cols="12">   
                    <v-autocomplete
                      v-model="tenantAgentContactFilter"
                      :loading="tenantAgentContacts.loading"
                      :items="tenantAgentContacts.items"
                      :search-input.sync="tenantAgentContacts.search"
                      cache-items
                      flat
                      hide-no-data
                      clearable
                      small-chips
                      outlined      
                      deletable-chips
                      hide-details
                      multiple
                      item-text="name"
                      item-value="id"
                      label="Tenant Agent Contacts"
                      @change="() => {getData();}"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                  <v-divider class="my-8"></v-divider>

                  <v-checkbox @change="() => {getData();}" v-model="vacantFilter" class="ma-0 pa-0"
                            label="Hide Vacant"></v-checkbox>

                <v-row>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="addressConfirmedFilter"
                      :items="[{value:'yes', name:'Yes'}, {value:'no', name:'No'}]"
                      cache-items
                      outlined
                      dense
                      hide-details
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="value"
                      label="Address Confirmed"
                      @change="getData"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="subscribedFilter"
                      :items="[{value:'yes', name:'Yes'}, {value:'no', name:'No'}]"
                      cache-items
                      outlined
                      dense
                      hide-details
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="value"
                      label="Subscribed"
                      @change="getData"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                  <!--<v-autocomplete-->
                  <!--v-model="landlordFilter"-->
                  <!--:loading="landlords.loading"-->
                  <!--:items="landlords.items"-->
                  <!--:search-input.sync="landlords.search"-->
                  <!--cache-items-->
                  <!---->
                  <!--hide-no-data-->
                  <!--clearable-->
                  <!--item-text="name"-->
                  <!--item-value="id"-->
                  <!--label="Landlord"-->
                  <!--@change="getData"-->
                  <!--&gt;</v-autocomplete>-->
                  <!--<v-autocomplete-->
                  <!--v-model="tenantFilter"-->
                  <!--:loading="tenants.loading"-->
                  <!--:items="tenants.items"-->
                  <!--:search-input.sync="tenants.search"-->
                  <!--cache-items-->
                  <!---->
                  <!--hide-no-data-->
                  <!--clearable-->
                  <!--item-text="name"-->
                  <!--item-value="id"-->
                  <!--label="Tenant"-->
                  <!--@change="getData"-->
                  <!--&gt;</v-autocomplete>-->

                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="rentFrom"
                        type="number"
                        label="Rent Min"
                        @blur="rentFrom ? (rentFrom = parseFloat(rentFrom).toFixed(2)) : null"
                        @change="getData"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="rentTo"
                        type="number"
                        label="Rent Max"
                        @blur="rentTo ? (rentTo = parseFloat(rentTo).toFixed(2)) : null"
                        @change="getData"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        :error-messages="formErrors.leaseStartFrom"
                        v-model="leaseStartFrom"
                        label="Lease Start From"
                        placeholder="dd/mm/yyyy"
                        persistent-hint
                        v-mask="'##/##/####'"
                        return-masked-value
                        @change="validateLeaseStartFrom()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        :error-messages="formErrors.leaseStartTo"
                        v-model="leaseStartTo"
                        label="Lease Start To"
                        placeholder="dd/mm/yyyy"
                        persistent-hint
                        v-mask="'##/##/####'"
                        return-masked-value
                        @change="validateLeaseStartTo()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <!-- date validation -->
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        :error-messages="formErrors.leaseEndFrom"
                        v-model="leaseEndFrom"
                        label="Lease End From"
                        placeholder="dd/mm/yyyy"
                        persistent-hint
                        v-mask="'##/##/####'"
                        return-masked-value
                        @change="validateLeaseEndFrom()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pl-2">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        :error-messages="formErrors.leaseEndTo"
                        v-model="leaseEndTo"
                        label="Lease End To"
                        placeholder="dd/mm/yyyy"
                        persistent-hint
                        v-mask="'##/##/####'"
                        return-masked-value
                        @change="validateLeaseEndTo()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              </v-menu>
            <!-- <v-btn class="ml-2 elevation-0" color="primary" flat @click="exportProperties" :loading="isExporting">
              <span class="mr-2">Export</span>
              <v-icon size="20">mdi-file-excel</v-icon>
            </v-btn> -->
            <v-text-field
              v-model="search"
              append-icon="mdi-table-search"
              label="Search"
              single-line
              dense
              outlined
              hide-details
              class="pt-0"

            ></v-text-field>
          <!--<div class="flex-grow-1"></div>-->
          <!--<v-row justify="end">-->
          <!--<v-col lg="6">-->
          </div>
        </div>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          style="border: 1px solid #e0e0e0; border-radius: 4px;"
          :headers="headers"
          :items="records"
          :options.sync="pagination"
          :loading="loading"
          :server-items-length="totalRecords"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :page.sync="page"
          :multi-sort="false"
          :scrollable="false"
          :footer-props="{
                            'items-per-page-options': [10, 50, 100, 500],
                          }"
          :custom-sort="customSort"
        >
          <template v-slot:body="{ items }" >
            <tbody v-if="initLoader">
                <tr v-for="n in 12" :key="n">
                  <td class="px-0 table-loading"  :colspan="headers.length">
                    <v-skeleton-loader
                      type="list-item"
                    ></v-skeleton-loader>
                  </td>
                </tr>
              </tbody>
            <tbody v-else-if="records.length > 0">
              <tr v-for="item in items" :key="item.id" class="data-table__row">
                <td>{{ item.building_num }}</td>
                <td>{{ item.address.data.full_address }}</td>
                <!--<td>{{ item.scheme.data.name}}</td>-->
                <td>
                  <a v-if="item.scheme_id" @click="viewScheme(item.scheme_id)">
                    {{ item.scheme.data.name }}
                  </a>
                </td>
                <td>{{ item.nia_sqrt }}</td>
                <td>{{ item.mezzanine }}</td>
                <td>{{ item.garden_centre }}</td>
                <td v-if="tableType == 'upcoming_lease_renewals' && !showLeaseInfo" :class="leaseInfoIfNotOwnerOccupied(item, 'lease_end_date_past')?'red--text':''">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'lease_end_date') }}<span class="grey--text text--lighten"
                                                                                v-if="!item.lease_end_date && item.public_lease_end_date"> {{ item.public_lease_end_date }}</span>

                </td>

                <td v-else-if="tableType != 'upcoming_lease_renewals'"> {{ leaseInfoIfNotOwnerOccupied(item, 'next_review_date') }}<span class="grey--text text--lighten"
                  v-if="!item.next_review_date && item.public_next_review_date"> {{ item.public_next_review_date }}</span></td>
                <td :class="leaseInfoIfNotOwnerOccupied(item, 'lease_start_date_future')?'red--text':''"
                    v-if="showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'lease_start_date') }}<span class="grey--text text--lighten"
                                                                                  v-if="!item.lease_start_date && item.public_lease_start_date"> {{ item.public_lease_start_date }}</span>
                  <!--                <v-icon v-if="isLeaseInfoPrivate(item, 'lease_start_date')" small class="mr-2" color="green darken-1" style="font-size: 10px;">mdi-circle</v-icon>-->
                </td>
                <td :class="leaseInfoIfNotOwnerOccupied(item, 'lease_end_date_past')?'red--text':''" v-if="showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'lease_end_date') }}<span class="grey--text text--lighten"
                                                                                v-if="!item.lease_end_date && item.public_lease_end_date"> {{ item.public_lease_end_date }}</span>
                </td>
                <td v-if="showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'break_date') }}<span class="grey--text text--lighten"
                                                                            v-if="!item.break_date && item.public_break_date"> {{ item.public_break_date }}</span>
                </td>
                <td v-if="showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'rent_pa') | moneyNoDecimal(item.currency) }}<span class="grey--text text--lighten" v-if="!item.rent_pa && item.public_rent_pa"> {{ item.public_rent_pa | money(item.public_currency) }}</span>
                </td>
                <td v-if="showBaseCurrency && showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'rent_pa_base') | money($auth.user().currency) }}<span class="grey--text text--lighten" v-if="!item.rent_pa_base && item.public_rent_pa_base"> {{ item.public_rent_pa_base | money($auth.user().currency) }}</span>
                </td>
                <td v-if="showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'rent_sqft') | money(item.currency) }}<span class="grey--text text--lighten"
                                                                                                  v-if="!item.rent_sqft && item.public_rent_sqft"> {{ item.public_rent_sqft | money(item.public_currency) }}</span>
                </td>
                <td v-if="showBaseCurrency && showLeaseInfo">
                  {{ leaseInfoIfNotOwnerOccupied(item, 'rent_sqft_base') | money($auth.user().currency) }}<span class="grey--text text--lighten" v-if="!item.rent_sqft_base && item.public_rent_sqft_base"> {{ item.public_rent_sqft_base | money($auth.user().currency) }}</span>
                </td>

                  <td v-if="showLeaseInfo">
                    {{ leaseInfoIfNotOwnerOccupied(item, 'rateable_value') | money(item.currency) }}<span class="grey--text text--lighten"
                                                                                                          v-if="!item.rateable_value && item.public_rateable_value"> {{ item.public_rateable_value | money(item.public_currency) }}</span>
                  </td>
                  <td v-if="showBaseCurrency && showLeaseInfo">
                    {{ leaseInfoIfNotOwnerOccupied(item, 'rateable_value_base') | money($auth.user().currency) }}<span class="grey--text text--lighten"
                                                                                                        v-if="!item.rateable_value_base && item.public_rateable_value_base"> {{ item.public_rateable_value_base | money($auth.user().currency) }}</span>
                  </td>
                    <td v-if="showLeaseInfo">
                      {{ leaseInfoIfNotOwnerOccupied(item, 'service_charge') | moneyNoDecimal(item.currency) }}<span class="grey--text text--lighten"
                                                                                                            v-if="!item.service_charge && item.public_service_charge"> {{ item.public_service_charge | money(item.public_currency) }}</span>
                    </td>
                    <td v-if="showBaseCurrency && showLeaseInfo">
                      {{ leaseInfoIfNotOwnerOccupied(item, 'service_charge_base') | money($auth.user().currency) }}<span class="grey--text text--lighten"
                                                                                                                        v-if="!item.service_charge_base && item.public_service_charge_base"> {{ item.public_service_charge_base | money($auth.user().currency) }}</span>
                    </td>
                    <td v-if="showLeaseInfo">
                      {{ leaseInfoIfNotOwnerOccupied(item, 'planning') }}<span class="grey--text text--lighten"
                                                                              v-if="!item.planning && item.public_planning"> {{ item.public_planning }}</span>
                    </td>

                    <td v-if="showLeaseInfo">
                      {{ leaseInfoIfNotOwnerOccupied(item, 'incentive') }}<span class="grey--text text--lighten"
                                                                                v-if="!item.incentive && item.public_incentive"> {{ item.public_incentive }}</span>
                    </td>

                    <td>
                      <a v-if="item.company_id" @click="$refs.editCompanyDialog.showDialog(item.company_id)">
                        {{ item.tenant.data.name }}
                        <v-tooltip bottom v-if="item.tenant.data.core_id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="green"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-checkbox-marked-circle-outline
                            </v-icon>
                          </template>
                          <span>Verified by RPD</span>
                        </v-tooltip>
                      </a>
                      <span v-else>{{ item.original_tenant }}</span>
                    </td>
                    <td>
                      <a class="mr-1" v-for="(company, index) in item.tenant_agents.data"
                        @click="$refs.editCompanyDialog.showDialog(company.id)">
                        {{ company.name }}<span v-if="index !== (item.tenant_agents.data.length - 1)">,</span>
                      </a>
                    </td>
                    <td>
                      <a class="mr-1" v-for="(user, index) in item.tenant_agent_contacts.data" @click="$refs.editUserDialog.showDialog(user.id)">
                        {{ user.name }}<span v-if="index !== (item.tenant_agent_contacts.data.length - 1)">,</span>
                      </a>
                    </td>
                    <td>
                      <a class="mr-1" v-for="(company, index) in item.landlords.data"
                        @click="$refs.editCompanyDialog.showDialog(company.id)">
                        {{ company.name }}<span v-if="index !== (item.landlords.data.length - 1)">,</span>
                      </a>
                    </td>
                    <td>
                      <a class="mr-1" v-for="(company, index) in item.landlord_agents.data"
                        @click="$refs.editCompanyDialog.showDialog(company.id)">
                        {{ company.name }}<span v-if="index !== (item.landlord_agents.data.length - 1)">,</span>
                      </a>
                    </td>
                    <td>
                      <a class="mr-1" v-for="(user, index) in item.landlord_agent_contacts.data" @click="$refs.editUserDialog.showDialog(user.id)">
                        {{ user.name }}<span v-if="index !== (item.landlord_agent_contacts.data.length - 1)">,</span>
                      </a>
                    </td>

                    <!--                            <td v-if="isAdmin()">-->
                    <!--                                <a @click="$refs.historyDialog.showDialog(item.id, 'property', item.scheme_id?null:'standalone')">-->
                    <!--                                    {{item.history_count}}-->
                    <!--                                </a>-->
                    <!--                            </td>-->
                    <!--<td class="justify-center layout px-0">-->
                    <td class="text-center data-table__frozen-right">
                      <v-menu v-if="item.unverified_history_count > 0"
                              max-width="200px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="mr-2"
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-help
                          </v-icon>
                        </template>

                        <v-card>
                          <v-card-text>
                                                <span>There are some changes to this entity that have not been verified by admin.
                                                    Please <a
                                                    @click="routeToEdit(item.id, item.scheme_id, 'entityHistoryBlock')">view the history of the entity</a> to see more information.</span>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                      <v-icon @click="routeToEdit(item.id, item.scheme_id)"
                              small
                              class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon title="View Scheme" v-if="item.scheme_id" @click="viewScheme(item.scheme_id)"
                              small
                              class="mr-2"
                      >
                        mdi-home-group
                      </v-icon>
                      <v-icon v-if="isAdmin()" @click="deleteItem(item.id, item.address.data.full_address)"
                              small
                              class="mr-2"
                      >
                        mdi-delete
                      </v-icon>
                      <v-icon class="mr-2" v-if="item.scheme_id" @click="routeToMap(item)" small title="View on map">
                        mdi-google-maps
                      </v-icon>
                    </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td style="padding-left: calc(50vw - 123px - 378px);" :colspan="headers.length + 1">
                  <span>It looks like you’re not set as a contact for any properties.
                  <v-menu offset-y>
                    <template v-slot:activator="{ on: onMenu }">
                            <a v-on="{...onMenu}" style="text-decoration: underline">Click here</a>
                    </template>
                    <v-list>
                      <v-list-item @click="() => routeToAddMe('scheme')">
                        <v-list-item-content>
                          <v-list-item-title>Add me as Landlord/Landlords Agent</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="() => routeToAddMe('property')">
                        <v-list-item-content>
                          <v-list-item-title>Add me as Tenant/Tenants Agent</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  to add yourself and start managing your properties.
                </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      
      <edit-scheme-dialog
        ref="editSchemeDialog"
      >
      </edit-scheme-dialog>
      <company-info-dialog ref="companyInfoDialog"></company-info-dialog>
      <!--                <history-dialog ref="historyDialog"></history-dialog>-->
      <!--<v-bottom-navigation-->
      <!--fixed-->
      <!--grow-->
      <!--v-model="tableType"-->
      <!--mandatory-->
      <!--&gt;-->
      <!--<v-btn value="all">-->
      <!--All-->
      <!--</v-btn>-->

      <!--<v-btn value="standalone">-->
      <!--Standalone properties-->
      <!--</v-btn>-->

      <!--<v-btn value="scheme">-->
      <!--Scheme properties-->
      <!--</v-btn>-->
      <!--</v-bottom-navigation>-->
      <!--<create-standalone-property-dialog ref="createStandalonePropertyDialog" @created="getData">-->

      <!--</create-standalone-property-dialog>-->
      <edit-property-dialog ref="editPropertyDialog" @updated="getData">

      </edit-property-dialog>
      <edit-standalone-property-dialog ref="editStandalonePropertyDialog" @updated="getData">

      </edit-standalone-property-dialog>
      <edit-company-dialog ref="editCompanyDialog"></edit-company-dialog>
      <edit-user-dialog ref="editUserDialog"></edit-user-dialog>
      <add-enquiries-dialog ref="addEnquiriesDialog" :propertyID="enquiry.property_id" :schemeID="enquiry.scheme_id"></add-enquiries-dialog>
      <tenant-contact-wizard ref="tenantContactWizard" @submitted="getData"></tenant-contact-wizard>
      <landlord-contact-wizard ref="landlordContactWizard" @submitted="getData"></landlord-contact-wizard>
      <!-- <v-btn
        fab
        dark
        bottom
        right
        fixed
        color="primary"
        :to="'/properties/create'"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-col>
  </v-row>

</template>

<script>
import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
import CompanyInfoDialog from '@/components/info/companyInfoDialog'
// import HistoryDialog from '@/components/common/historyDialog'
// import CreatePropertyDialog from "@/components/properties/createPropertyDialog";
import EditPropertyDialog from "@/components/properties/editPropertyDialog";
import EditStandalonePropertyDialog from "@/components/properties/editStandalonePropertyDialog";
// import CreateStandalonePropertyDialog from "@/components/properties/createStandalonePropertyDialog";
import {mask} from 'vue-the-mask'
import EditCompanyDialog from "@/components/companies/editCompanyDialog.vue";
import EditUserDialog from "@/components/users/editUserDialog.vue";
import addEnquiriesDialog from '@/components/enquiries/addEnquiriesDialog'

import TenantContactWizard from '@/components/properties/SetAsTenantContactWizard.vue'
import LandlordContactWizard from '@/components/properties/SetAsLandlordContactWizard.vue'

import { property } from 'lodash';

export default {
  components: {
    EditUserDialog,
    EditCompanyDialog,
    EditStandalonePropertyDialog,
    // CreateStandalonePropertyDialog,
    EditPropertyDialog,
    // CreatePropertyDialog,
    EditSchemeDialog,
    CompanyInfoDialog,
    addEnquiriesDialog,
    // HistoryDialog,
    TenantContactWizard,
    LandlordContactWizard,
  },
  directives: {
    mask,
  },
  data() {
    return {
      search: '',
      schemeFilter: null,

      enquiry: {
        property_id: null,
        scheme_id: null,
      },

      filtersMenu: false,
      isExporting: false,
      tableType: 'all',
      propertyType: false,
      showLeaseInfo: false,
      showBaseCurrency: false,

      formErrors: {
        leaseStartFrom: null,
        leaseEndFrom: null,
        leaseStartTo: null,
        leaseEndTo: null,
      },

      // search: '',
      pagination: {},
      totalRecords: 0,
      loading: true,
      initLoader: true,
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 50,
      page: 1,

      tabCount: {
        upcoming_rent_reviews: 0,
        upcoming_lease_renewals: 0,
        vacant: 0,
        without_lease: 0,
      },


      headers: [
        // {text: 'Unit', value: 'building_num'},
        // {text: 'Address', value: 'address_id'},
        // {text: 'Scheme', value: 'scheme_id'},
        // {text: 'NIA', value: 'nia_sqrt'},
        // {text: 'Tenant', value: 'company_id'},
        // {text: 'Landlords', value: 'landlords', sortable: false},
        // {text: 'Landlords Agents', value: 'landlord_agents', sortable: false},
        // {text: 'Actions', sortable: false, align: 'center'}
      ],
      defaultHeaders: [
        {text: 'Unit', value: 'building_num', class:'data-table__cell'},
        {text: 'Address', value: 'address_id', width: '300px'},
        {text: 'Scheme', value: 'scheme_id', width:'200px'},
        {text: 'NIA', value: 'nia_sqrt', class:'data-table__cell'},
        {text: 'Mezz/FF', value: 'mezzanine', class:'data-table__cell'},
        {text: 'GC', value: 'garden_centre', class:'data-table__cell'},
        {text: 'Next Review Date', value: 'next_review_date', class:'data-table__cell'},
        {text: 'Tenant', value: 'company_id', width:'200px'},
        {text: 'Tenant Agents', value: 'company_id', sortable: false, width:'250px'},
        {text: 'Tenant Contact', value: 'tenant_contacts', sortable: false, width:'250px'},
        {text: 'Landlords', value: 'landlords', sortable: false, width:'250px'},
        {text: 'Landlord Agents', value: 'landlord_agents', sortable: false, width:'250px'},
        {text: 'Landlord Agent Contacts', value: 'landlord_agent_contacts', sortable: false, width:'250px'},
        {text: 'Actions', align: 'center', sortable: false, width: '120px', class:'data-table__frozen-right'},
      ],
      leaseHeaders: [
        {text: 'Lease Start Date', value: 'lease_start_date', class:'data-table__cell'},
        {text: 'Lease End Date', value: 'lease_end_date', class:'data-table__cell'},
        // {text: 'Next Review Date', value: 'next_review_date', sortable: false},
        {text: 'Break Date', value: 'break_date', class:'data-table__cell'},
        {text: 'Rent Pa', value: 'rent_pa', class:'data-table__cell'},
        {text: 'Rent SQFT', value: 'rent_sqft', class:'data-table__cell'},
        {text: 'RV', value: 'rateable_value', class:'data-table__cell'},
        {text: 'S/C', value: 'service_charge', class:'data-table__cell'},
        {text: 'Planning', value: 'planning', class:'data-table__cell'},
        {text: 'Incentive', value: 'incentive', width: '150px'},
      ],
      upcomingLeaseHeaders: [
        {text: 'Unit', value: 'building_num', class:'data-table__cell'},
        {text: 'Address', value: 'address_id', width: '300px'},
        {text: 'Scheme', value: 'scheme_id', width:'200px'},
        {text: 'NIA', value: 'nia_sqrt', class:'data-table__cell'},
        {text: 'Mezz/FF', value: 'mezzanine', class:'data-table__cell'},
        {text: 'GC', value: 'garden_centre', class:'data-table__cell'},
        {text: 'Lease Expiry', value: 'lease_expiry', class:'data-table__cell'},
        {text: 'Tenant', value: 'company_id', class:'data-table__cell'},
        {text: 'Tenant Agents', value: 'company_id', sortable: false, width:'200px'},
        {text: 'Tenant Contact', value: 'tenant_contacts', sortable: false, width:'200px'},
        {text: 'Landlords', value: 'landlords', sortable: false, width:'200px'},
        {text: 'Landlords Agents', value: 'landlord_agents', sortable: false, class:'data-table__cell'},
        {text: 'Landlord Agent Contacts', value: 'landlord_agent_contacts', sortable: false, width:'250px'},
        {text: 'Actions', align: 'center', sortable: false, width: '120px'},
      ],
      leaseHeadersWithBaseCurrency: [
        {text: 'Lease Start Date', value: 'lease_start_date', sortable: false},
        {text: 'Lease End Date', value: 'lease_end_date', sortable: false},
        // {text: 'Next Review Date', value: 'next_review_date', sortable: false},
        {text: 'Break Date', value: 'break_date', sortable: false},
        {text: 'Rent Pa', value: 'rent_pa', sortable: false},
        {text: 'Rent Pa Base', value: 'rent_pa_base', sortable: false},
        {text: 'Rent SQFT', value: 'rent_sqft', sortable: false},
        {text: 'Rent SQFT Base', value: 'rent_sqft_base', sortable: false},
        {text: 'RV', value: 'rateable_value', sortable: false},
        {text: 'RV Base', value: 'rateable_value_base', sortable: false},
        {text: 'S/C', value: 'service_charge', sortable: false},
        {text: 'S/C Base', value: 'service_charge_base', sortable: false},
        {text: 'Planning', value: 'planning', sortable: false},
        {text: 'Incentive', value: 'incentive', sortable: false},
      ],
      records: [],
      landlords: {
        loading: false,
        items: [],
        search: null,
      },
      landlordAgents: {
        loading: false,
        items: [],
        search: null,
      },
      tenants: {
        loading: false,
        items: [],
        search: null,
      },
      legalTenants: {
        loading: false,
        items: [],
        search: null,
      },
      tenantContacts: {
        loading: false,
        items: [],
        search: null,
      },
      tenantAgent: {
        loading: false,
        items: [],
        search: null,
      },
      tenantAgentContacts: {
        loading: false,
        items: [],
        search: null,
      },
      landlordContacts: {
        loading: false,
        items: [],
        search: null,
      },
      landlordAgentContacts: {
        loading: false,
        items: [],
        search: null,
      },
      schemes: {
        loading: false,
        items: [],
        search: null,
      },
      _timerId: null,
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getData()
      },
      deep: true
    },
    search() {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.page = 1
        this.getData()
      }, 500)
    },
    page() {
      this.$vuetify.goTo(1)
    },
    'landlords.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlords()
      }, 375);
    },
    'landlordAgents.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgents()
      }, 375);
    },
    'tenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenants()
      }, 375);
    },
    'schemes.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getSchemes()
      }, 375);
    },
    'legalTenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLegalTenants(search);
      }, 375);
    },
    'tenantContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantContacts()
      }, 375);
    },
    'landlordContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordContacts()
      }, 375);
    },
    'landlordAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgentContacts()
      }, 375);
    },
    tableType(type) {
      if(this.tableType === 'upcoming_lease_renewals') {
        this.headers = [...this.upcomingLeaseHeaders];
      } else {
        this.headers = [...this.defaultHeaders];
      }

      if(this.showLeaseInfo) {
        const leaseHeaders = this.showBaseCurrency ? this.leaseHeadersWithBaseCurrency : this.leaseHeaders;
        if (this.tableType === 'upcoming_lease_renewals') {
          this.headers.splice(6, 1, ...leaseHeaders);
        } else {
          this.headers.splice(7, 0, ...leaseHeaders);
        }
      }

      this.getData()
    },
    propertyType(type) {
      this.getData()
    },
    showUnverified() {
      this.getData()
    },
    showBaseCurrency(value) {
      this.headers = [...this.defaultHeaders];

      const leaseHeaders = this.showLeaseInfo && value ? this.leaseHeadersWithBaseCurrency : this.leaseHeaders;
      this.headers.splice(7, 0, ...leaseHeaders);

      // this.getData()
    },
    showLeaseInfo(value) {
      if(this.tableType === 'upcoming_lease_renewals') {
        this.headers = [...this.upcomingLeaseHeaders];
      } else {
        this.headers = [...this.defaultHeaders];
      }
      // if(this.isAdmin()) {
      //     this.headers
      //         .splice(this.headers.length -1, 0, {text: 'Proposals', value: 'childs_count', sortable: false})
      // }
      if (value) {
        const leaseHeaders = this.showBaseCurrency? this.leaseHeadersWithBaseCurrency : this.leaseHeaders;

        if (this.tableType === 'upcoming_lease_renewals') {
          this.headers.splice(6, 1, ...leaseHeaders);
        } else {
          this.headers.splice(7, 0, ...leaseHeaders);
        }
      }

      this.getData()
    }
  },
  filters: {
    landlords(item) {
      return item.landlords.data.map(elem => {
        return elem.name;
      }).join(', ');
    },
    landlordAgents(item) {
      return item.landlord_agents.data.map(elem => {
        return elem.name;
      }).join(', ');
    },
    tenantContacts(item) {
      return item.tenant_agent_contacts.data.map(elem => {
        return elem.name;
      }).join(', ');
    },
    money(value, currency = 'GBP') {
      if (typeof value !== "number") {
        return value;
      }
      let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
    moneyNoDecimal(value, currency = 'GBP') {
      if (typeof value !== "number") {
        return value;
      }
      value = Math.trunc(value);
      let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,

      });
      
      return formatter.format(value);
    }
  },
  computed: {
    isFiltersActive() {
      return this.landlordFilter
        || this.landlordAgentFilter
        || this.tenantFilter
        || this.tenantLegalFilter
        || this.tenantContactFilter
        || this.landlordContactFilter
        || this.landlordAgentContactFilter
        || this.addressConfirmedFilter
        || this.subscribedFilter
        || this.sizeFrom
        || this.sizeTo
        || this.rentFrom
        || this.rentTo
        || this.leaseStartFrom
        || this.leaseStartTo
        || this.leaseEndFrom
        || this.leaseEndTo
        || this.vacantFilter;

    },

    filtersCount(){
      // return the number of filters that are active for the filters badge
      let count = 0;
      if(this.landlordFilter && this.landlordFilter.length > 0) count++;
      if(this.landlordAgentFilter && this.landlordAgentFilter.length > 0) count++;
      if(this.tenantFilter && this.tenantFilter.length > 0) count++;
      if(this.tenantLegalFilter && this.tenantLegalFilter.length > 0) count++;
      if(this.tenantContactFilter && this.tenantContactFilter.length > 0) count++;
      if(this.landlordContactFilter && this.landlordContactFilter.length > 0) count++;
      if(this.landlordAgentContactFilter && this.landlordAgentContactFilter.length > 0) count++;
      if(this.addressConfirmedFilter) count++;
      if(this.subscribedFilter) count++;
      if(this.sizeFrom) count++;
      if(this.sizeTo) count++;
      if(this.rentFrom) count++;
      if(this.rentTo) count++;
      if(this.leaseStartFrom) count++;
      if(this.leaseStartTo) count++;
      if(this.leaseEndFrom) count++;
      if(this.leaseEndTo) count++;
      if(this.vacantFilter) count++;
      return count;
    },

    landlordFilter: {
      get() {
        return this.$store.state.properties.filters.landlordFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'landlordFilter', value: value})
      }
    },
    landlordAgentFilter: {
      get() {
        return this.$store.state.properties.filters.landlordAgentFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'landlordAgentFilter', value: value})
      }
    },
    tenantFilter: {
      get() {
        return this.$store.state.properties.filters.tenantFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'tenantFilter', value: value})
      }
    },
    tenantLegalFilter: {
      get() {
        return this.$store.state.properties.filters.tenantLegalFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'tenantLegalFilter', value: value})
      }
    },
    tenantContactFilter: {
      get() {
        return this.$store.state.properties.filters.tenantContactFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'tenantContactFilter', value: value})
      }
    },
    landlordContactFilter: {
      get() {
        return this.$store.state.properties.filters.landlordContactFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'landlordContactFilter', value: value})
      }
    },
    landlordAgentContactFilter: {
      get() {
        return this.$store.state.properties.filters.landlordAgentContactFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'landlordAgentContactFilter', value: value})
      }
    },
    tenantAgentFilter: {
      get() {
        return this.$store.state.properties.filters.tenantAgentFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'tenantAgentFilter', value: value})
      }
    },
    tenantAgentContactFilter: {
      get() {
        return this.$store.state.properties.filters.tenantAgentContactFilter;
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'tenantAgentContactFilter', value: value})
      }
    },

    vacantFilter: {
      get() {
        return this.$store.state.properties.filters.vacantFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'vacantFilter', value: value})
      }
    },

    letFilter: {
      get() {
        return this.$store.state.properties.filters.letFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'letFilter', value: value})
      }
    },

    addressConfirmedFilter: {
      get() {
        return this.$store.state.properties.filters.addressConfirmedFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'addressConfirmedFilter', value: value})
      }
    },
    subscribedFilter: {
      get() {
        return this.$store.state.properties.filters.subscribedFilter
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'subscribedFilter', value: value})
      }
    },
    showUnverified: {
      get() {
        return this.$store.state.properties.filters.showUnverified
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'showUnverified', value: value})
      }
    },
    sizeFrom: {
      get() {
        return this.$store.state.properties.filters.sizeFrom
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'sizeFrom', value: value})
      }
    },
    sizeTo: {
      get() {
        return this.$store.state.properties.filters.sizeTo
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'sizeTo', value: value})
      }
    },
    rentFrom: {
      get() {
        return this.$store.state.properties.filters.rentFrom
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'rentFrom', value: value})
      }
    },
    rentTo: {
      get() {
        return this.$store.state.properties.filters.rentTo
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'rentTo', value: value})
      }
    },
    leaseStartFrom: {
      get() {
        return this.$store.state.properties.filters.leaseStartFrom
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'leaseStartFrom', value: value})
      }
    },
    leaseStartTo: {
      get() {
        return this.$store.state.properties.filters.leaseStartTo
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'leaseStartTo', value: value})
      }
    },
    leaseEndFrom: {
      get() {
        return this.$store.state.properties.filters.leaseEndFrom
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'leaseEndFrom', value: value})
      }
    },
    leaseEndTo: {
      get() {
        return this.$store.state.properties.filters.leaseEndTo
      },
      set(value) {
        this.$store.commit('updatePropertiesFilters', {key: 'leaseEndTo', value: value})
      }
    },
  },
  methods: {
    badgeMargin(count) {
      // return an increase in the margin for the badge based on the digit, the breakpoints increasing at 10, 100, 1000, 10000, 100000 etc
      if (count < 10) return 5;
      if (count < 100) return 15;
      if (count < 1000) return 25;
      if (count < 10000) return 30;
      else return 35;
    },

     async handleRouteQuery(){
        const query = this.$route.query;
        console.log(query);
        if (query.id) {
            if (query.type === 'property') {
                this.enquiry.property_id = query.id;
            } else {
                this.enquiry.scheme_id = query.id;
            }
            // 0.5s delay
            
            setTimeout(() => {
                this.$refs.addEnquiriesDialog.showDialog();
            }, 500);
        }
    },

    routeToAddMe(type) {
      if(type === 'scheme') {
        // this.$router.push({name: 'setMeAsLandlordContact'})
        this.$refs.landlordContactWizard.openDialog();
      }
      if(type === 'property') {
        // this.$router.push({name: 'setMeAsTenantContact'})
        this.$refs.tenantContactWizard.openDialog();
      }
    },

    resetFilters() {
      this.landlordFilter = null;
      this.landlordAgentFilter = null;
      this.tenantFilter = null;
      this.tenantLegalFilter = null;
      this.tenantContactFilter = null;
      this.landlordContactFilter = null;
      this.landlordAgentContactFilter = null;
      this.vacantFilter = null;
      this.addressConfirmedFilter = null;
      this.subscribedFilter = null;
      this.sizeFrom = null;
      this.sizeTo = null;
      this.rentFrom = null;
      this.rentTo = null;
      this.leaseStartFrom = null;
      this.leaseStartTo = null;
      this.leaseEndFrom = null;
      this.leaseEndTo = null;
      this.search = '';
      this.getData();
    },

    async getSchemes() {
      const response = await this.$http.get('/schemes/', {
        params: {
          q: this.schemes.search,
          per_page: 100,
        }
      });
      this.schemes.items = response.data.data;
    },

    leaseInfoIfNotOwnerOccupied(property, key) {
      if (property.scheme_id) {
        return property[key]
      }

      let ownerOccupied = property.landlords.data.filter((item) => {
        return item.id === property.company_id;
      }).length > 0;

      if (ownerOccupied) {
        return '';
      }

      return property[key]
    },

    getLeaseInfo(property, key) {
      if (key === 'lease_start_date_future') {
        if (property['lease_start_date']) {
          return property['lease_start_date_future'];
        } else if (property['public_lease_start_date']) {
          return property['public_lease_start_date_future'];
        }
      }
      if (key === 'lease_end_date_past') {
        if (property['lease_end_date']) {
          return property['lease_end_date_past'];
        } else if (property['public_lease_end_date']) {
          return property['public_lease_end_date_past'];
        }
      }
      return property[key] || property['public_' + key]
    },

    isLeaseInfoPrivate(property, key) {
      return property[key] !== null
    },

    viewScheme(id) {
      this.$refs.editSchemeDialog.showDialog(id);
    },

    routeToEdit(id, schemeId, scroll) {
      if (schemeId) {
        this.$refs.editPropertyDialog.showDialog(id, schemeId, false, scroll);
      } else {
        this.$refs.editPropertyDialog.showDialog(id);

      }
    },

    routeToCreate() {
      this.$refs.createStandalonePropertyDialog.showDialog();
    },
    
    routeToMap(item) {
      if (item.scheme_id) {
        this.$router.push({name: 'map', params: {scheme: item.scheme.data}})
      }
    },

    validateLeaseStartFrom() {
      this.formErrors.leaseStartFrom = this.validateDate(this.leaseStartFrom);
    },

    validateLeaseEndFrom() {
      this.formErrors.leaseEndFrom = this.validateDate(this.leaseEndFrom);
    },

    validateLeaseStartTo() {
      this.formErrors.leaseStartTo = this.validateDate(this.leaseStartTo);
    },

    validateLeaseEndTo() {
      this.formErrors.leaseEndTo = this.validateDate(this.leaseEndTo);
    },

    validateDate(date){
      if(date){
        let dateArray = date.split('/');
        let day = parseInt(dateArray[0]);
        let month = parseInt(dateArray[1]);
        let year = parseInt(dateArray[2]);
        if(day > 31 || day < 1 || month > 12 || month < 1 || year < 1 || year > 9999 || !day || !month || !year){

          return 'Invalid date format, please use dd/mm/yyyy';
        }
        this.getData();
        return null;
      }
    },
    
    customSort: function(items, index, isDesc) {
      console.log('customSort', items, index, isDesc);
      items.sort((a, b) => {
        if (index === "next_review_date" || index === "lease_start_date" || index === "lease_end_date" || index === "break_date") {
          if (!isDesc) {
            return compare(a.date, b.date);
          } else {
            return compare(b.date, a.date);
          }
          }else {
            if (!isDesc) {
              return a[index] < b[index] ? -1 : 1;
            } else {
              return b[index] < a[index] ? -1 : 1;
            }
          }
      });
      console.log(items);
      return items;
    },

    exportProperties() {
      this.isExporting = true;
      this.$http.get('/properties/export', {
        responseType: 'blob',
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          my_type: this.tableType,
          lease_info: this.showLeaseInfo ? 1 : 0,
          is_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
        },
      }).then((response) => {
        this.isExporting = false;
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'properties.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((e) => {
        this.isExporting = false;
      });
    },
    async deleteCompany(id, name) {

      this.$notify.question(`Do you want to remove ${name}?`, () => {
        this.$http.delete(`/companies/${id}`).then(() => {
          this.getData()
        })
      })
    },
    async deleteItem(id, name) {
      const {data} = await this.$http.get(`/properties/${id}/check-destroy`);
      let clientsWarning = ''
      let filesWarning = ''
      let commentsWarning = ''
      if (data.clients) {
        this.$notify.warn('Private data exists!', `${data.clients} has private data on this property!`);
        clientsWarning = `${data.clients} has private data on this property!`
      }
      if (data.comments) {
        commentsWarning = `</br><b>${data.comments} comments!</b>`
      }
      if (data.files) {
        filesWarning = `</br><b>${data.files} files!</b>`
      }
      this.$notify.question(`Do you want to remove ${name}?</br> Property cannot be recovered and is not saved in history!</br><b>${clientsWarning}</b>${filesWarning}${commentsWarning}`, () => {
        this.$http.delete(`/properties/${id}`).then(() => {
          this.getData()
        })
      })
    },
    getData() {
      this.loading = true
      // this.page = 1
      this.$http.get('/properties', {
        params: {
          q: this.search,
          page: this.pagination.page,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.pagination.itemsPerPage,
          include: 'address,landlords,landlord_agents,landlord_agent_contacts,tenant,scheme,tenant_agent_contacts,tenant_agents',
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          my_type: this.tableType,
          address_confirmed: this.addressConfirmedFilter,
          subscribed: this.subscribedFilter,
          show_unverified: this.showUnverified ? 1 : 0,
          hide_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
          // my_contact_type: this.propertyType === true ? ['landlord', 'landlord_agent', 'tenant', 'tenant_agent'] : null,
          include_company: this.propertyType === true ? 1 : null,
        }
      }).then(response => {
        const pagination = response.data.meta.pagination
        this.totalRecords = pagination.total
        this.records = response.data.data.map(item => {
          if (this.isAdmin()) {
            item.lease_start_date = item.public_lease_start_date;
            item.lease_end_date = item.public_lease_end_date;
            item.next_review_date = item.public_next_review_date;
            item.break_date = item.public_break_date;
            item.rent_pa = item.public_rent_pa;
            item.rent_pa_base = item.public_rent_pa_base;
            item.rent_sqft = item.public_rent_sqft;
            item.rent_sqft_base = item.public_rent_sqft_base;
            item.incentive = item.public_incentive;
            item.rateable_value = item.public_rateable_value;
            item.rateable_value_base = item.public_rateable_value_base;
            item.service_charge = item.public_service_charge;
            item.service_charge_base = item.public_service_charge_base;
            item.planning = item.public_planning;
            item.currency = item.public_currency;
          }
          item.nia_sqrt = item.nia_sqrt ? item.nia_sqrt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null
          item.mezzanine = item.mezzanine ? item.mezzanine.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null
          item.garden_centre = item.garden_centre ? item.garden_centre.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null
          return item
        })
        this.loading = false
        this.initLoader = false
      }).catch(() => {
        this.loading = false
        this.initLoader = false
      })
    },
    async getCompanyById(id) {
      const response = await this.$http.get(`/companies/${id}`);
      return response.data;
    },
    async getContactById(id) {
      const response = await this.$http.get(`/users/${id}`);
      return response.data;
    },
    async getLandlords() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlords.search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
    },
    async getLandlordAgents() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.landlordAgents.search,
          per_page: 100,
        }
      });
      this.landlordAgents.items = response.data.data;
    },
    async getTenants() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.tenants.search,
          per_page: 100,
        }
      });
      this.tenants.items = response.data.data;
    },
    async getLegalTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.legalTenants.items = response.data.data;
    },
    async getTenantContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.tenantContacts.search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },
    async getLandlordContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordContacts.search,
          per_page: 100,
        }
      });
      this.landlordContacts.items = response.data.data;
    },
    async getLandlordAgentContacts() {
      const response = await this.$http.get('/users/', {
        params: {
          q: this.landlordAgentContacts.search,
          per_page: 100,
        }
      });
      this.landlordAgentContacts.items = response.data.data;
    },
    formatDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async getTabCount(){
      const response = await this.$http.get('/properties/my-counts', {
        params: {
          is_my_properties: 1,
          include_company: this.propertyType === true ? 1 : null,
        }
      });

      this.tabCount.upcoming_rent_reviews = response.data.upcoming_rent_reviews
      this.tabCount.upcoming_lease_renewals = response.data.upcoming_lease_renewals
      this.tabCount.vacant = response.data.vacant
      this.tabCount.without_lease = response.data.without_lease
    },

    getTabCountOld(){
      // run all the requests for upcoming rent reviews, lease renewals, vacant and without lease and take the count from the pagination in the response
        this.$http.get('/properties', {
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          lease_info: this.showLeaseInfo ? 1 : 0,
          is_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
          my_type: 'upcoming_rent_reviews'
        }
      }).then(response => {
        this.tabCount.upcoming_rent_reviews = response.data.meta.pagination.total
      })
      this.$http.get('/properties', {
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          lease_info: this.showLeaseInfo ? 1 : 0,
          is_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
          my_type: 'upcoming_lease_renewals'
        }
      }).then(response => {
        this.tabCount.upcoming_lease_renewals = response.data.meta.pagination.total
      })
      this.$http.get('/properties', {
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          lease_info: this.showLeaseInfo ? 1 : 0,
          is_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
          my_type: 'vacant'
        }
      }).then(response => {
        this.tabCount.vacant = response.data.meta.pagination.total
      })
      this.$http.get('/properties', {
        params: {
          q: this.search,
          sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
          desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
          landlord_id: this.landlordFilter,
          landlord_agent_id: this.landlordAgentFilter,
          tenant_id: this.tenantFilter,
          legal_tenant_id: this.tenantLegalFilter,
          tenant_contact_id: this.tenantContactFilter,
          landlord_contact_id: this.landlordContactFilter,
          landlord_agent_contact_id: this.landlordAgentContactFilter,
          size_min: this.sizeFrom,
          size_max: this.sizeTo,
          rent_min: this.rentFrom,
          rent_max: this.rentTo,
          from_lease_start: this.formatDate(this.leaseStartFrom),
          to_lease_start: this.formatDate(this.leaseStartTo),
          from_lease_end: this.formatDate(this.leaseEndFrom),
          to_lease_end: this.formatDate(this.leaseEndTo),
          lease_info: this.showLeaseInfo ? 1 : 0,
          is_vacant: this.vacantFilter ? 1 : 0,
          is_base_currency: this.showBaseCurrency ? 1 : 0,
          scheme_id: this.schemeFilter,
          is_my_properties: 1,
          my_type: 'without_lease'
        }
      }).then(response => {
        this.tabCount.without_lease = response.data.meta.pagination.total
      })
    },

    debounce(fn, delay) {
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        fn();
      }, delay);
    }

  },
  mounted() {
    this.getTabCount()
    this.headers = this.defaultHeaders;
    this.handleRouteQuery();
  }
}
</script>

<style scoped>
.table-link {
  text-decoration: none;
}

/*table tbody tr td {*/
/*white-space: nowrap;*/
/*}*/
</style>
